// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Job",
  bookSlug: "job",
  chapter: 35,
  argument: "Eliu declares that the good or evil done by man cannot reach God.",
  verses: [
    { n: 1, text: "Moreover Eliu spoke these words." },
    { n: 2, text: "Doth thy thought seem right to thee, that thou shouldst say: I am more just than God?" },
    { n: 3, text: "For thou saidst: That which is right doth not please thee: or what will it profit thee if I sin?" },
    { n: 4, text: "Therefore I will answer thy words, and thy friends with thee." },
    { n: 5, text: "Look up to heaven and see, and behold the sky, that it is higher than thou." },
    { n: 6, text: "If thou sin, what shalt thou hurt him? and if thy iniquities be multiplied, what shalt thou do against him?" },
    { n: 7, text: "And if thou do justly, what shalt thou give him, or what shall he receive of thy hand?" },
    { n: 8, text: "Thy wickedness may hurt a man that is like thee: and thy justice may help the son of man." },
    { n: 9, text: "By reason of the multitude of oppressors they shall cry out: and shall wail for the violence of the arm of tyrants." },
    { n: 10, text: "And he hath not said: Where is God, who made me, who hath given songs in the night?" },
    { n: 11, text: "Who teacheth us more than the beasts of the earth, and instructeth us more than the fowls of the air." },
    { n: 12, text: "There shall they cry, and he will not hear, because of the pride of evil men." },
    { n: 13, text: "God therefore will not hear in vain, and the Almighty will look into the causes of every one." },
    { n: 14, text: "Yea, when thou shalt say: He considereth not: be judged before him, and expect him." },
    { n: 15, text: "For he doth not now bring on his fury, neither doth he revenge wickedness exceedingly." },
    { n: 16, text: "Therefore, Job openeth his mouth in vain, and multiplieth words without knowledge." },
  ],
  commentary: [
    { verse: 2, notes: [
      { text: "God. Eliu being greatly mortified at Job's silence, uses still more provoking expressions, and pretends to refute one of the holy man's assertions, which never escaped his lips, though he had complained that God treated him as an enemy, and with more severity than his sins deserved; (chap. vi. 2.; Calmet) or, that his affliction was greater than his sin, chap. xxiii. 7., &c. Eliu therefore calumniates him.", attribution: "Worthington" }
    ] },
    { verse: 3, notes: [
      { text: "Please thee, since thou punishest the guiltless. (Menochius) — If I sin. Job had not said so, but it seemed to follow from his expressions, chap. xxi. 7. See chap. xxii. 3. Whether sin be committed and punished, or not, what does it profit God? (Calmet) — His sovereign perfections require that he should not let sin pass unnoticed, and Job never entertained an idea to the contrary.", attribution: "Haydock" }
    ] },
    { verse: 4, notes: [
      { text: "Thee. I will shew that you are all wrong. (Haydock) — I will supply what the three have left imperfect.", attribution: "Calmet" }
    ] },
    { verse: 5, notes: [
      { text: "Thee. Thy sin cannot hurt, nor thy virtue add any thing to God. He is not therefore actuated by resentment, or jealousy, but by justice. (Calmet) — He revenges the injury done by the sinner to himself,", attribution: "Haydock" }
    ] },
    { verse: 8, notes: [
      { text: "(St. Augustine, Conf. iii. 8.) — The inference is therefore wrong, (Calmet) that God will not regard the sins or punishment of men, because he thence derives no profit,", attribution: "Haydock" }
    ] },
    { verse: 9, notes: [
      { text: "Out. The wicked shall cry out, through vexation, but still they will not address themselves to God,", attribution: "Haydock" }
    ] },
    { verse: 10, notes: [
      { text: "Why are they abandoned, but because He takes cognizance of all?", attribution: "Haydock" }
    ] },
    { verse: 11, notes: [
      { text: "Air: and yet the wicked make not use of their understanding, to have recourse to God under distress.", attribution: "Calmet" }
    ] },
    { verse: 13, notes: [
      { text: "Vain. Hebrew, \"falsehood.\" He will not relieve the hypocrite, who does not cry to him with sincerity. This conduct shews that God acts with discretion, and hears people according to their deserts.", attribution: "Calmet" }
    ] },
    { verse: 14, notes: [
      { text: "Before him. Try whether the assertion be true. (Haydock) — Only change thy life, and hope in him, and thou wilt see the good effects.", attribution: "Calmet" }
    ] },
    { verse: 15, notes: [
      { text: "For. Protestants, \"But now because it is not so, he hath visited in his anger; yet he (marginal note, Job) knoweth it not, in great extremity.\" (Haydock) — In this world, God punishes not with rigour.", attribution: "Calmet" }
    ] },
    { verse: 16, notes: [
      { text: "Knowledge. I have shewn that God punishes or rewards according to our deserts, and is not indifferent about our sins. If Job have not experienced the divine bounty, it is because he has not deserved it.", attribution: "Calmet" }
    ] },
  ],
};

export default chapter;
